import { random } from 'lodash';

const uuid = window.localStorage.getItem('qm.session') || random(999999);

const returnAuthToken = () => {
  const cookie = document.cookie;
  if (cookie.indexOf('qm.jwt') > -1) {
    return cookie.split('qm.jwt=')[1].split(';')[0];
  }
};

export const Headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${returnAuthToken()}`,
  'Session-uuid': uuid,
};
